export const LEAVING_ENGINE_PROPERTIES_CHANGES =
  'CONFIRM_LEAVING_ENGINE_PROPERTIES_CHANGES';
export const LEAVING_ENGINE_PUBLISH_CONFIRM =
  'CONFIRM_LEAVING_ENGINE_PUBLISH_CONFIRM';
export const LEAVING_USERGROUP_FORM_CONFIRM = 'LEAVING_USERGROUP_FORM_CONFIRM';
export const LEAVING_USERGROUP_SETTINGS_CONFIRM =
  'LEAVING_USERGROUP_SETTINGS_CONFIRM';
